export default "<ng-container *ngIf='articulo'>\n<span [innerHtml]='articulo.descripcion | safeHtml'></span>\n</ng-container>\n";